import * as React from 'react';
import Payment from 'payment';
import { Rule, RulesMessages, ValidationResponse } from '../utils/validator';
import TextInput from './TextInput';
import { HatType } from './Hat';

interface CreditCardInputProps {
  placeHolder?: string;
  name: string;
  value?: string;
  id: string;
  label?: string;
  required?: boolean;
  hasError: boolean;
  errors?: any;
  theme?: 'night' | 'day';
  validationRules?: Rule[];
  rulesMessages?: RulesMessages;
  onChange?: Function;
  onComplete?: (cardNumber: string) => void;
  onError?: Function;
  onBlur?: Function;
  onEsc?: (cardNumber: string) => void;
  onEnter?: (cardNumber: string) => void;
  onLeft?: (cardNumber: string) => void;
  onRight?: (cardNumber: string) => void;
  onUp?: (cardNumber: string) => void;
  onDown?: (cardNumber: string) => void;
  onSpace?: (cardNumber: string) => void;
  hat?: HatType[];
  readOnly?: boolean;
  disabled?: boolean;
  iconPath?: string;
  toolTip?: React.ReactNode;
  autocomplete?: string;
}

interface CreditCardInputState {
  inputValue: string;
  validationResponse?: ValidationResponse;
}

export default function CreditCardInput(props: CreditCardInputProps) {
  const [state, setState] = React.useState<CreditCardInputState>({
    inputValue: props.value || ''
  });
  const { label = 'Card Number' } = props;
  const componentPropsRules: Rule[] = [];

  componentPropsRules.push({
    ruleName: 'cardNumber',
    message: props.rulesMessages && props.rulesMessages.cardNumber,
    defaultMessage: `${label} is not a valid credit card number.`,
    dependsOn: ['minLength']
  });

  return (
    <TextInput
      placeHolder={props.placeHolder}
      rulesMessages={props.rulesMessages}
      name={props.name}
      inputMode="numeric"
      value={state.inputValue}
      id={props.id}
      label={label}
      required={props.required}
      hasError={props.hasError}
      errors={props.errors}
      theme={props.theme}
      onComplete={props.onComplete}
      onError={props.onError}
      onBlur={props.onBlur}
      autocomplete={props.autocomplete}
      onChange={(event: any) => {
        const { target } = event;
        const input = target.value;
        target.value = null;
        target.value = Payment.fns.formatCardNumber(input);
        setState({ ...state, inputValue: target.value });
        if (props.onChange !== undefined) {
          props.onChange({
            ...event,
            target: { ...event.target, cardType: Payment.fns.cardType(input) }
          });
        }
      }}
      onEsc={(inputValue: string) => {
        if (props.onEsc !== undefined) {
          props.onEsc(inputValue);
        }
      }}
      onEnter={(inputValue: string) => {
        if (props.onEnter !== undefined) {
          props.onEnter(inputValue);
        }
      }}
      onUp={(inputValue: string) => {
        if (props.onUp !== undefined) {
          props.onUp(inputValue);
        }
      }}
      onDown={(inputValue: string) => {
        if (props.onDown !== undefined) {
          props.onDown(inputValue);
        }
      }}
      onLeft={(inputValue: string) => {
        if (props.onLeft !== undefined) {
          props.onLeft(inputValue);
        }
      }}
      onRight={(inputValue: string) => {
        if (props.onRight !== undefined) {
          props.onRight(inputValue);
        }
      }}
      onSpace={(inputValue: string) => {
        if (props.onSpace !== undefined) {
          props.onSpace(inputValue);
        }
      }}
      validationRules={componentPropsRules}
      minLength={13}
      maxLength={state.inputValue.includes(' ') ? 19 : 16}
      allowRegex={/^[0-9\s]*$/}
      hat={props.hat}
      readOnly={props.readOnly}
      disabled={props.disabled}
      iconPath={props.iconPath}
      toolTip={props.toolTip}
    />
  );
}
